import React from 'react';
import withSession from 'chameleon/packages/blue-book-player/hocs/withSession';

const withSessionOnStudentAccountOnly = (Component) => (props) => {
  const { isStudent, isImpersonating } = props?.userData || {};

  if (isStudent && !isImpersonating) {
    const WrappedComponent = withSession(Component);
    return <WrappedComponent {...props} />;
  }

  return <Component {...props} />;
};

export default withSessionOnStudentAccountOnly;
